const src = document.currentScript ? (document.currentScript as HTMLScriptElement).src.slice() : null;

export { src };
